var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollBox"},_vm._l((_vm.numPages),function(item){return _c('pdf',{key:item,ref:"pdf",refInFor:true,attrs:{"src":_vm.pdfSrc,"page":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }